
import './polyfill';//'./polyfill.js';
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from 'react';
import ReactDOM from 'react-dom';
import store from './store';
// import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
// import thunk from 'redux-thunk';
// import { ClearCacheProvider, useClearCacheCtx } from 'react-clear-cache';
// import reducer from './store/reducer/reducer';
// import commonReducer from './store/reducer/commonReducer';
// import FileImportReducer from './store/reducer/FileImportReducer';
// import ProfileReducer from './store/reducer/ProfileReducer';
// import formBuilderReducer from './store/reducer/formBuilderReducer';
import Routes from './Global/Routes';
import './i18n';
// import GridFilterReducer from './store/reducer/GridFilterReducer';
import * as serviceWorker from './serviceWorker';
// import ReportReducer from './store/reducer/ReportReducer';
// import ShippingReducer from './store/reducer/ShippingReducer';
// import RateConfigReducer from './store/reducer/RateConfigReducer';

// const rootReducer = combineReducers({
//   reducer : reducer,
//   commonReducer : commonReducer,
//   FileImportReducer : FileImportReducer,
//   ProfileReducer : ProfileReducer,
//   formBuilder : formBuilderReducer,
//   GridFilterReducer:GridFilterReducer,
//   ReportReducer:ReportReducer,
//   ShippingReducer:ShippingReducer,
//   RateConfigReducer:RateConfigReducer

// });
// const store = createStore(rootReducer, applyMiddleware(thunk));

ReactDOM.render(
  // <ClearCacheProvider auto={true}>
    <Provider store={store}>
      <Routes />
    </Provider>
  // </ClearCacheProvider>
  ,
  document.getElementById('root')
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register({
//   onUpdate: (registration) => {
//     console.log('New content is available; please refresh..');
//     if (window.confirm('New update available. Reload now?')) {
//       window.location.reload();
//     }
//   },
//   onSuccess: (registration) => {
//     console.log('Content cached for offline use.');
//   },
// });

// serviceWorker.register({
//   onUpdate: (registration) => {
//     console.log('New content is available; please refresh.');

//     // Notify the user about the update
//     // if (window.confirm('A new update is available. Would you like to update now?')) {
//     //   if (registration && registration.waiting) {
//     //     // Skip the waiting state and activate the new service worker
//     //     registration.waiting.postMessage({ type: 'SKIP_WAITING' });

//     //     // Refresh the page to load the new content
//     //     window.location.reload();
//     //   }
//     // }
//   },
//   onSuccess: (registration) => {
//     console.log('Content cached for offline use.');
//   },
// });

// serviceWorker.register({
//   onUpdate: (registration) => {
//       if (registration && registration.waiting) {
//           // Activate the new service worker immediately
//           registration.waiting.postMessage({ type: 'SKIP_WAITING' });

//           // Automatically refresh the page
//           window.location.reload();
//       }
//   },
//   onSuccess: () => {
//       console.log('Content cached for offline use.');
//   },
// });

// if ('serviceWorker' in navigator) {
//   // Listen for changes to the active service worker
//   navigator.serviceWorker.addEventListener('controllerchange', () => {
//     console.log('Service worker controller has changed.');

//     // Optionally reload the page
//     alert('A new version of the app is available. Reloading...');
//     window.location.reload();
//   });
// }
serviceWorker.unregister();
